define('modules/overlay-box',[
  'jquery',

  'utils/dim',
  'utils/bind-manager',
  'utils/tooltip-init',
  'utils/body-scroll',
  'utils/bind-lifo-stack',
  'utils/toast',
  'utils/translate',
  'settings',
  'utils/ajax-util',

  'handlebars'
], function ($, dim, bindMng, tooltipInit, bodyScroll, bindStack, Toast, t, settings, ajax, Handlebars) {
  /**
   * @class OverlayBox
   */
  var OverlayBox = (function () {
    var template =
        '<div class="overlay-box overlay-box__action-close"><div class="overlay-box__inner-wrapper"><a href="#" class="overlay-box__close-button overlay-box__action-close">&times;</a><div class="overlay-box__content"><div style="padding: 2rem"><span class="loader"></span></div></div></div></div>',
      blankTemplate =
        '<div class="overlay-box overlay-box__action-close"><div class="overlay-box__inner-wrapper overlay-box__inner-wrapper--blank"><div class="overlay-box__content"></div></div></div>',
      borderlessTemplate =
        '<div class="overlay-box overlay-box__action-close"><div class="overlay-box__inner-wrapper"><a href="#" class="overlay-box__close-button overlay-box__action-close">&times;</a><div class="overlay-box__content borderless"><span class="loader"></span></div></div></div>';
    videoTemplate =
      '<div class="overlay-box overlay-box__video overlay-box__action-close"><div class="overlay-box__video__body"><div class="overlay-box__video__inner"><div class="overlay-box__video__wrap"><a class="overlay-box__video__close-btn overlay-box__action-close" aria-label="Close"></a><div class="overlay-box__content video"></div></div></div></div></div>';

    /**
     * Overlay Box is somewhat similar to a lightbox
     *
     * @param source
     * @param data
     * @constructor
     */
    function OverlayBox(source, data) {
      this.templateSource = source;
      this.dataSource = data;

      this.destroyList = $.Deferred();
      this.storedTemplates = {};
    }

    /**
     * Setup the overlay box so that it exists in the DOM
     *
     * @method setup
     */
    OverlayBox.prototype.setup = function (isBlank, isBorderless, isVideo) {
      var container = $('.overlay-box');

      if (container.length > 0) {
        container.remove();
      }

      this.container = $(
        isBlank ? blankTemplate : isBorderless ? borderlessTemplate : isVideo ? videoTemplate : template
      ).appendTo('body');
    };

    /**
     * Load the contents of the overlay box (both template and source data)
     *
     * @method load
     * @param callback
     */
    OverlayBox.prototype.load = function (callback) {
      var _this = this;

      this.loadTemplate(function (templateSource) {
        var template = Handlebars.compile(templateSource);

        // Trigger templateLoaded event
        $(_this).trigger('templateLoaded');

        _this.loadData(function (context) {
          var html = template(context);

          _this.container.find('.overlay-box__content').html(html);
          _this.bindEscape();
          _this.bindClose();

          tooltipInit(_this.container);

          // Rebind since the DOM changed
          bindMng.rebind();

          if (callback !== undefined) {
            callback(_this.container);
          }

          // Trigger dataLoaded event
          $(_this).trigger({
            type: 'dataLoaded',
            content: context
          });
        });
      });
    };

    /**
     * Loads the template data either directly from the given
     * object or from a JSON resource using Ajax
     *
     * @method loadData
     * @param callback
     */
    OverlayBox.prototype.loadData = function (callback) {
      var _this = this;

      if (typeof this.dataSource == 'object') {
        callback(this.dataSource);
      } else if (typeof this.dataSource == 'string') {
        $.getJSON(this.dataSource)
          .success(callback)
          .fail(function () {
            Toast.queueError(t('Failed to load content.'));
            _this.hide();
          });
      }
    };

    /**
     * Loads the template either from the DOM or using Ajax
     *
     * @method loadTemplate
     * @param callback
     */
    OverlayBox.prototype.loadTemplate = function (callback) {
      var _this = this;

      if (typeof this.templateSource == 'object') {
        callback(this.templateSource.html());
      } else if (typeof this.templateSource == 'string') {
        if (this.templateSource in this.storedTemplates) {
          callback(this.storedTemplates[this.templateSource]);
        } else {
          ajax.get(this.templateSource).then(
            function (content) {
              _this.storedTemplates[_this.templateSource] = content;
              callback(content);
            },
            function(error) {
              console.log('Could not load ob-template.');
              _this.destroy();
            });
        }
      }
    };

    /**
     * Binds escape key to close the overlay box
     *
     * @method bindEscape
     */
    OverlayBox.prototype.bindEscape = function () {
      var _this = this;

      bindStack.pushEscapeCallback(function (e) {
        _this.destroy();
      });

      this.destroyList.done(function () {
        bindStack.popEscapeCallback();
      });
    };

    /**
     * Bind close listener to close the overlay box
     *
     * @method bindClose
     */
    OverlayBox.prototype.bindClose = function () {
      var _this = this,
        eventCallback = function (e) {
          if ($(e.target).hasClass('overlay-box__action-close')) {
            e.preventDefault();
            _this.destroy();
          }
        };

      $('html').on('click', '.overlay-box', eventCallback);

      this.destroyList.done(function () {
        $('html').off('click', '.overlay-box', eventCallback);
      });
    };

    /**
     * Shows the overlay box if it's hidden and dims the rest of
     * the site
     *
     * @method show
     */
    OverlayBox.prototype.show = function () {
      dim.dim();

      this.container.show();
      this.container.fadeTo(0, 1);

      bodyScroll.lock();
      this.destroyList.done(function () {
        bodyScroll.unlock();
      });
    };

    /**
     * Hides the overlay box
     *
     * @method hide
     */
    OverlayBox.prototype.hide = function () {
      var _this = this;

      dim.clear();

      this.container.css({
        opacity: 0
      });

      setTimeout(function () {
        _this.container.hide();
        bodyScroll.unlock();
      }, settings.transitionTime);
    };

    /**
     * Adds callback to destroy fn
     * @param {Function} callback
     */

    OverlayBox.prototype.addDestroyCallback = function (callback) {
      this.destroyCallback = callback;
    };

    /**
     * First hides the overlay box and then removes it
     * completely from the DOM
     *
     * @method destroy
     */
    OverlayBox.prototype.destroy = function () {
      var _this = this;
      this.hide();
      setTimeout(function () {
        _this.container.remove();
      }, settings.transitionTime);

      this.destroyList.resolve();
      if (this.destroyCallback) {
        this.destroyCallback.call();
      }
    };

    /**
     * Shows fullscreen loader
     * @method showLoader
     * @return {OverlayBox}
     */
    OverlayBox.showLoader = function (cb) {
      var loader = new OverlayBox($('#overlaybox-loader'), {});
      loader.setup(true, false);
      loader.load();
      loader.show();
      loader.addDestroyCallback(cb);
      return loader;
    };

    return OverlayBox;
  })();

  return OverlayBox;
});

